import { useJss } from 'lq-ui'

export default () => {
  const useStyles = useJss({})
  const classes = useStyles()
  return classes
}
